/**
 * Session bearer lives in sessionStorage (tab-scoped), not localStorage.
 * Survives refresh within the tab; clears when the tab closes — reduces
 * persistent XSS token theft vs localStorage. Full HttpOnly BFF cookies
 * remain the longer-term production target.
 */

const TOKEN_KEY = 'access_token';
const USER_KEY = 'user';

function ss() {
  try {
    return typeof sessionStorage !== 'undefined' ? sessionStorage : null;
  } catch {
    return null;
  }
}

function ls() {
  try {
    return typeof localStorage !== 'undefined' ? localStorage : null;
  } catch {
    return null;
  }
}

/** Drop any legacy localStorage session leftovers. */
export function clearLegacyLocalSession() {
  const store = ls();
  if (!store) return;
  try {
    store.removeItem(TOKEN_KEY);
    store.removeItem(USER_KEY);
  } catch {
    /* ignore */
  }
}

/**
 * Read token: prefer sessionStorage; one-time migrate from localStorage.
 */
export function getAccessToken() {
  const session = ss();
  if (session) {
    const fromSession = session.getItem(TOKEN_KEY);
    if (fromSession) return fromSession;
  }
  const local = ls();
  if (!local) return '';
  try {
    const legacy = local.getItem(TOKEN_KEY);
    if (!legacy) return '';
    if (session) {
      session.setItem(TOKEN_KEY, legacy);
      const user = local.getItem(USER_KEY);
      if (user) session.setItem(USER_KEY, user);
    }
    clearLegacyLocalSession();
    return legacy;
  } catch {
    return '';
  }
}

export function getStoredUserJson() {
  const session = ss();
  if (session) {
    const fromSession = session.getItem(USER_KEY);
    if (fromSession) return fromSession;
  }
  const local = ls();
  if (!local) return null;
  try {
    return local.getItem(USER_KEY);
  } catch {
    return null;
  }
}

export function setStoredSession(token, user) {
  const session = ss();
  if (session) {
    if (token) session.setItem(TOKEN_KEY, token);
    else session.removeItem(TOKEN_KEY);
    if (user != null) {
      session.setItem(USER_KEY, typeof user === 'string' ? user : JSON.stringify(user));
    }
  }
  clearLegacyLocalSession();
}

export function clearStoredSessionKeys() {
  const session = ss();
  if (session) {
    try {
      session.removeItem(TOKEN_KEY);
      session.removeItem(USER_KEY);
    } catch {
      /* ignore */
    }
  }
  clearLegacyLocalSession();
}
